import { observable } from 'mobx'

export default class LoginError {

  @observable message: string|void = ''

  constructor(origError) {
    this.message = origError.message
  }

}



// WEBPACK FOOTER //
// ./src/auth/LoginError.js